import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Image,
  Input,
  Select,
  Space,
  TimePicker,
  Upload,
  notification
} from "antd";
import { GrUpload } from "react-icons/gr";
import SalonRequest from "./SalonRequest";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const CreateUser = ({ form, onFinishUser, setLoading }) => {

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);


  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };


  const uploadButton = (
    <button style={{ border: 0, background: "none" }}>
      <GrUpload />
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  const handleImageChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    if (newFileList.length > 0) {
      const newFile = newFileList[0];
      setPreviewImage(newFile.url || newFile.preview);
    } else {
      setPreviewImage("");
    }
  };

  const imageUpload = (file, name) => {
    setLoading(true);
    const modifiedFile = new File([file], name, { type: file.type });
    let formData = new FormData();
    formData.append("file", modifiedFile);
    formData.append("fileName", name);
    SalonRequest
      .uploadImage(formData)
      .then((res) => {
        setLoading(false);
        form.setFieldsValue({
          profileImage: res?.data?.uploadDirectory,

        });
        console.log(res)
        if (res) {
          return true;
        } else {
          return false;
        }
      })
      .catch((e) => {
        setLoading(false);
        notification["error"]({
          message: "File upload Failed",
        })
      }
      );
  };

  const props = {
    name: "file",
    multiple: false,
    beforeUpload: (file) => {
      imageUpload(file, file.name);
      return false;
    },
    onRemove() {
      setFileList([]);
    },
  };



  return (
    <>
      <section>
        <div className="Create-Category">

          <Form
            layout="vertical"
            className="subscription-form"
            form={form}
            onFinish={onFinishUser}
          >
            <div className="subscription">
              <Form.Item
                label="User Name"
                name="name"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter the user name!" },
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message: "User name can only contain alphabetic characters and spaces!",
                  },
                  {
                    min: 3,
                    message: "User name must be at least 3 characters long!",
                  },
                  {
                    max: 20,
                    message: "User name cannot exceed 20 characters!",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter user name" />
              </Form.Item>

              <Form.Item
                label="Gender"
                name="gender"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please select the salon type" },
                ]}
              >
                <Select
                  placeholder="Select Gender"
                  style={{
                    marginTop: "0.5rem",

                    width: "99%",
                  }}
                  // onChange={handleChange}
                  options={[
                    {
                      value: "0",
                      label: "Male",
                    },
                    {
                      value: "1",
                      label: "Female",
                    },
                  ]}
                />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                label="Email"
                name="emailId"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter the email!" },
                  { type: "email", message: "Please enter a valid email!" },
                ]}
              >
                <Input size="large" placeholder="Enter Email" />
              </Form.Item>

              <Form.Item
                label="Mobile Number"
                name="mobileNumber"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter the mobile number!" },
                  { pattern: /^[0-9]{10}$/, message: "Mobile number must be exactly 10 digits!" },
                ]}
              >
                <Input size="large" placeholder="Enter Mobile Number" />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                label="Password"
                name="password"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter the password!" },
                  {
                    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                    message: "Password must be at least 8 characters, include one uppercase letter, one lowercase letter, one number, and one special character!",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter Password" />
              </Form.Item>

            </div>

            <div className="upload-Img">
              <Form.Item
                label="Upload User Image "
                name="profileImage"
                className="subscription-plan"
                rules={[{ required: true, message: "Please upload the salon images" }]}
              >
                <Upload {...props} maxCount={1}

                  listType="picture-card"
                  fileList={fileList}
                  className="upload-Img-input"
                  onPreview={handlePreview}
                  onChange={handleImageChange}
                >
                  {fileList.length >= 8 ? null : uploadButton}
                </Upload>
                {previewImage && (
                  <Image
                    wrapperStyle={{ display: "none" }}
                    preview={{
                      visible: previewOpen,
                      onVisibleChange: (visible) => setPreviewOpen(visible),
                      afterOpenChange: (visible) => !visible && setPreviewImage(""),
                    }}
                    src={previewImage}
                  />
                )}
              </Form.Item>
            </div>
            <div className="steps-action">
              <Button type="primary" htmlType="submit">
                Next
              </Button>
            </div>

          </Form>
        </div>
      </section>
    </>
  );
};

export default CreateUser;
